// extracted by mini-css-extract-plugin
module.exports = {"defaultFullPageTextModule":"DefaultFullPageText_defaultFullPageTextModule__ZWLjG","tableWrapper":"DefaultFullPageText_tableWrapper__c0qR5"};